import SiteHero from "@/components/SiteHero";
import { HERO } from "@/lib/heroConfig";

const Hero = () => {
  return <SiteHero {...HERO.home} />;
};

export default Hero;
